import { resolveProductSchemaKey } from './productPosDescription';

export const SCHEMA_TO_CATALOG_PREFIX = {
  smartphone: 'SM',
  tablet: 'TB',
  carregador: 'CHG',
  laptop: 'LP',
  desktop: 'DS',
  servidor: 'SW',
  all_in_one: 'AIO',
  monitor_tv: 'MN',
};

const LEGACY_PREFIX_ALIASES = {
  AI: 'AIO',
  SC: 'MN',
  MB: 'SM',
};

export const resolveCatalogCategoryPrefix = (categoryValue, fallbackSku = '') => {
  const normalizedValue = String(categoryValue || '').trim().toUpperCase().replace(/\s+/g, '_');

  if (SCHEMA_TO_CATALOG_PREFIX[resolveProductSchemaKey(categoryValue)]) {
    return SCHEMA_TO_CATALOG_PREFIX[resolveProductSchemaKey(categoryValue)];
  }

  if (LEGACY_PREFIX_ALIASES[normalizedValue]) {
    return LEGACY_PREFIX_ALIASES[normalizedValue];
  }

  if (Object.values(SCHEMA_TO_CATALOG_PREFIX).includes(normalizedValue)) {
    return normalizedValue;
  }

  const normalizedSku = String(fallbackSku || '').trim().toUpperCase();
  const knownPrefixes = Object.values(SCHEMA_TO_CATALOG_PREFIX).sort((a, b) => b.length - a.length);
  const matchedPrefix = knownPrefixes.find((prefix) => normalizedSku.startsWith(prefix));
  return matchedPrefix || null;
};